import React from "react";
import { Marker, Polygon, Tooltip, useMap } from "react-leaflet";
import { getSVGIcon } from "./helper";
import "leaflet/dist/leaflet.css";
import { MarkerPopup } from "./LayersHelpers";
import { useSelector } from "react-redux";

export const LayerFeedingSubstations = props => {
    const map = useMap();
    const { feedingSubstations } = useSelector(
        (state) => state.state.electricity
    );

    if (!feedingSubstations) {
        return <></>
    }
    const zoom = map.getZoom()
    const markers = feedingSubstations.map(mark => {
        if (!mark.x_y_coord || mark.x_y_coord === "") {
            return null;
        }

        let type = 'feedingSubstation'

        return (

            <Marker
                position={[
                    mark.x_y_coord.split(' ')[1],
                    mark.x_y_coord.split(' ')[0],
                ]}
                icon={getSVGIcon(type, zoom > 14 ? {
                    text: mark.name
                } : null)}
                key={mark.fid}
                data={mark.fid}
                type={mark.type}
                pane="otherPane"

            >
                <Tooltip
                    direction="top"
                    key={`${mark.fid}_tooltip`}

                >{mark.name}
                </Tooltip>
                <MarkerPopup host={mark} key={`popup_${mark.fid}`} />

                {
                    zoom > 14 ?
                        // <>
                        <Polygon
                            positions={mark.coordinates}
                            fillColor="#96CD93"
                            fillOpacity={0.5}
                            color="#40A438"
                            key={`${mark.fid}_polygon`}
                        />


                        : null
                }
            </Marker>

        );
    }).filter(Boolean);
    return markers;
}
